export default __webpack_public_path__ + "static/media/exitSplit.b75c2f6f.svg";